export const appArrowLeftDisabledIcon = {
    data: `<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.2397 15.4L22.8369 14L16.825 20L22.8369 26L24.2397 24.6L19.6305 20L24.2397 15.4Z" fill="#BDBDBD"/></svg>`,
    name: 'arrow-left-disabled'
};